<tt-page class="col-xs-12 col-md-6 sp-0">
    <tt-card>
        <tt-button-goto ttText="workgrps_new" ttGoto="workgrp" [ttGotoParms]="{ workgrp_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list [ttData]="itemsListCapacityGroups"></tt-list>
</tt-page>
